import React from 'react';
import { Stack, Typography } from '@mui/material';
import { useListCountriesQuery } from '../api/brokerGroupsApi';
import { useListAllFeatureFlagsQuery } from '@/admin/featureFlags/api/featureFlagsApi';
import { BROKER_GROUP_FIELD_LABELS } from './brokerGroupFormValues';

/**
 * The save confirmation's list of changes, one "Field: old → new" line each (from
 * getBrokerGroupChanges), then the feature flags being turned on and off for the broker
 * group (featureFlagChanges, from getFeatureFlagChanges) by name. Countries show by name;
 * empty values as "(none)".
 */
export const BrokerGroupChangeList = ({ changed, before, after, featureFlagChanges }) => {
	const { data: countries = {} } = useListCountriesQuery();
	const { data: flags = [] } = useListAllFeatureFlagsQuery();
	const flagNames = (ids) =>
		ids.map((id) => flags.find((flag) => flag.id === id)?.feature ?? id).join(', ');
	const flagLines = [
		['Turn on', featureFlagChanges.added],
		['Turn off', featureFlagChanges.removed],
	].filter(([, ids]) => ids.length);

	const displayValue = (field, value) => {
		if (value === null || value === undefined || value === '') return '(none)';
		if (field === 'country') return countries[value]?.countryName ?? value;
		return String(value);
	};

	return (
		<Stack spacing={0.5}>
			{changed.map((field) => (
				<Typography key={field}>
					<span style={{ fontWeight: 'bold' }}>
						{`${BROKER_GROUP_FIELD_LABELS[field]}: `}
					</span>
					<span>
						{`${displayValue(field, before[field])} → ${displayValue(field, after[field])}`}
					</span>
				</Typography>
			))}
			{flagLines.map(([label, ids]) => (
				<Typography key={label}>
					<span style={{ fontWeight: 'bold' }}>{`${label} feature flags: `}</span>
					<span>{flagNames(ids)}</span>
				</Typography>
			))}
		</Stack>
	);
};
